import { FormValidator, ValidationResult } from '../formField/types/form-validator';

/**
 * This is a totally customizable validator, whose logic can be injected
 * through a function that will perform the actual validation and return the validation result.
 * The injected function can have multiple return branches, with different error messages
 *
 * @param {(value, params?) => ValidationResult} func
 * @param {object | undefined} params
 * @returns {(value: string) => Promise<ValidationResult>}
 * @constructor
 */
export const CustomizableValidator: (func: Function, params?: object) => FormValidator = (
  func: (value, params?) => ValidationResult,
  params
) => {
  return async (value: string): Promise<ValidationResult> => {
    return func(value, params);
  };
};
